export default function header() {
    const params = new URLSearchParams(window.location.search);
    const searchQuery = params.get('s');

    Alpine.data('header', () => ({
        clearSearch() {
            this.searchQuery = '';
        },
        closeAll() {
            if (this.megamenuOpen) this.megamenuOpen = false;
            if (this.searchOpen) this.searchOpen = false;
        },
        closeSearch() {
            this.searchOpen = false;
        },
        init() {
            // Add a CTRL/CMD + K shortcut to open the search.
            window.addEventListener('keydown', (event) => {
                if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
                    event.preventDefault();
                    this.searchQuery = '';
                    if (window.matchMedia('(min-width: 1024px)').matches) {
                        this.megamenuOpen = false;
                        this.$nextTick(() => this.$refs.searchInputDesktop.focus());
                    } else {
                        this.searchOpen = true;
                        this.$nextTick(() => this.$refs.searchInputMobile.focus());
                    }
                }
            });
        },
        megamenuOpen: false,
        toggleMegamenu() {
            this.megamenuOpen = !this.megamenuOpen;
            if (this.megamenuOpen) {
                this.searchOpen = false;
            }
        },
        searchOpen: false,
        searchQuery: searchQuery || '',
        toggleMobileSearch() {
            this.searchOpen = !this.searchOpen;
            if (this.searchOpen) {
                this.megamenuOpen = false;
                this.$nextTick(() => this.$refs.searchInputMobile.focus());
            }
        },
    }));
}
